import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "emoji-thumb" }, null, -1)

import { Chat } from "@/store/chats/types";
import { useComputedValue } from "@/composables";
import { ActionTypes, GetterTypes } from "@/store";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { REACTIONS_EMOJI_CHARACTERS } from "@/data/emoji/emojiCharacters";
import MessageEmojiReactionsPanelItem from "../MessageEmojiReactionsPanelItem/MessageEmojiReactionsPanelItem.vue";

interface MessageEmojiReactionsPanelProps {
  messageId: string;
  isMine: boolean;
}

interface Emits {
  (e: "closePanel"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageEmojiReactionsPanel',
  props: {
    messageId: {},
    isMine: { type: Boolean }
  },
  emits: ["closePanel"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const { dispatch } = useStore();
const props = __props;
const chat = useComputedValue<Chat>(GetterTypes.GET_SELECTED_CHAT);
const chatId = computed(() => chat.value.id);
const isEnlarged = ref(false);

const addReaction = async (emoji: string) => {
  emit("closePanel");
  await dispatch(ActionTypes.SEND_MESSAGE_REACTION, {
    messageId: props.messageId,
    chatId: chatId.value,
    reaction: emoji,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-emoji-reactions-emojis-panel", { isMine: _ctx.isMine }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(REACTIONS_EMOJI_CHARACTERS), (emoji, i) => {
      return (_openBlock(), _createBlock(MessageEmojiReactionsPanelItem, {
        key: i,
        emoji: emoji,
        onInsertEmoji: addReaction
      }, null, 8, ["emoji"]))
    }), 128)),
    _hoisted_1
  ], 2))
}
}

})